import type { ChangelogEntry } from "../types";

/** Opprydding i Måltall, første del: felles sidepanel og «Om tallene». */
export const MALTALL_OPPRYDDING_2026_10: ChangelogEntry = {
  id: "2026-10-27-maltall-opprydding",
  date: "2026-10-27",
  title: "Måltall forklarer tallene sine",
  summary: "Nedbrytninger åpnes i et sidepanel, og hver widget har en knapp som forklarer hvordan tallene regnes.",
  sections: [
    {
      heading: "Måltall",
      items: [
        {
          title: "Nedbrytninger i sidepanel",
          kind: "forbedret",
          body: "Klikk på en måned, en person eller en salgsenhet åpner nedbrytningen i et panel fra høyre i stedet for en boks midt på skjermen. På mobil fyller panelet hele skjermen.",
        },
        {
          title: "«Om tallene» på hver widget",
          kind: "nytt",
          body: "Knappen (i) ved tittelen forklarer hva tallet svarer på, hvordan det regnes, og hvorfor det kan avvike fra tall andre steder.",
        },
        {
          title: "Nøkkeltall og kompakt bonusmål i ny Måltall",
          kind: "nytt",
          featureFlag: "feature_maaltall_v2",
          body: "Ny Måltall starter med fire nøkkeltall: omsetning hittil i år, resultat, GEEK solgt denne måneden og GEEK i tilbudspipen. Under står bonusmålene på én rad. Klikk på et tall for å se prosjektene og månedene bak.",
        },
        {
          title: "Hvor teamets kapasitet gikk",
          kind: "nytt",
          featureFlag: "feature_maaltall_v2",
          minRole: "admin",
          body: "Faktureringsgraden viser hvor kapasiteten gikk: godkjente oppgaver, oppgaver som venter, kundeprosjekt uten oppgave, interne prosjekter og timer som ikke er ført. Søyler per måned, og drill ned til hvilke dager hver ansatt mangler føring.",
        },
        {
          title: "Dette bør du se på",
          kind: "nytt",
          featureFlag: "feature_maaltall_v2",
          minRole: "admin",
          body: "Faste sjekker viser prosjekter som venter på avslutning, rest som skulle vært fakturert, tilbud uten sannsynlighet, oppgaver som venter på godkjenning og måneder uten timer, med listen bak hvert funn og tommel opp eller ned.",
        },
        {
          title: "Feilbudsjettering per produkt",
          kind: "nytt",
          featureFlag: "feature_maaltall_v2",
          body: "Hvilke produkter vi selger for mange eller for få timer av, på avsluttede prosjekter i år, med linjene og oppgavene bak. Prosjektledere ser sine egne prosjekter.",
        },
        {
          title: "Prosjekter som venter, Topp 5 og Reell timepris",
          kind: "forbedret",
          featureFlag: "feature_maaltall_v2",
          body: "Prosjekter som er klare til å avsluttes og rest som skulle vært fakturert står samlet. Topp 5 og Reell timepris er hvert sitt kort med veksler i stedet for to.",
        },
        {
          title: "Mine tall og Mitt salg",
          kind: "nytt",
          featureFlag: "feature_maaltall_v2",
          body: "Ansatte ser egen faktureringsgrad og budsjettavvik i ett kort, med hvilke dager som mangler føring. Er du med i en salgsenhet, ser du også enhetens GEEK mot målet.",
        },
        {
          title: "Måltall i seksjoner, som i den godkjente skissen",
          kind: "forbedret",
          featureFlag: "feature_maaltall_v2",
          body: "Ledervisningen er delt i Selskapet nå, Team, Økonomi framover og Rangering. Budsjettavvik står kompakt ved siden av feilbudsjettering per produkt, og Reell timepris viser snittet med en strek og de prosjektene som trekker ned. Selgere ser Mitt salg i stedet for GEEK-mål per selger.",
        },
        {
          title: "Drill helt ned i alle tall",
          kind: "forbedret",
          featureFlag: "feature_maaltall_v2",
          body: "Faktureringsgraden går fra måned og kategori ned til hver føring og hver dag uten føring. Prosjekter i Topp 5 og bonusmålene åpner budsjettlinjer og oppgaver, med reell timepris for avsluttede prosjekter. Budsjettavvik og Mine tall åpner prosjekter og oppgaver i sidepanelet, og Resultat viser inntekter og kostnader per måned og kontoklasse.",
        },
        {
          title: "Tabellen «Aktive prosjekter – fakturering» er fjernet",
          kind: "forbedret",
          minRole: "admin",
          body: "Den store tabellen over alle aktive prosjekter er tatt bort fra Måltall. Hva som gjenstår å fakturere på et prosjekt, står på prosjektkortet.",
        },
      ],
    },
  ],
};
